module.exports = __webpack_public_path__ + "assets/img/14_918.cef69dc2.jpg";